<template>
  <div id='app'>
    <overwatchLoader id='loader' v-if='connected===null'/>
    <network/>
    <error :error='error'/>
    <router-view v-if="(connected === true && user) || (connected === false)"/>
  </div>
</template>

<script>
import Network from './tools/network/network.vue'
import Error from './components/error/error'
import packageJson from '../package.json'
import OverwatchLoader from './components/loader/overwatch'

export default {
  name: 'app',
  components: {
    Network,
    Error,
    OverwatchLoader
  },
  data: function () {
    return {
      error: null,
    }
  },
  mounted () {
    this.init();
  },
  computed: {
    device: function () {
      return this.$store.getters.device
    },
     user () {
      return this.$store.getters.user
    },
    connected () {
      return this.$store.state.connected
    },
    wsStatus () {
      return this.$store.state.wsStatus
    }
  },
  methods: {
    init () {
      console.log("init");
      this.getPackage()
      this.$authManager.auth(true)
      .then(user => {
        if (this.$route.query.deviceId) {
          this.getDevice()
        } else {
          this.getSite()
        }
      }).catch(error => {
        if (this.$route.name !== 'Params') {
          // this.error = { title: 'Authentication required', message: error.message } // dont display this error on params form
        }
        console.log(error)
        this.$store.commit('setConnected', false)
        setTimeout(() => {
          this.init();
        }, 10000);
      })
    },
    getDevice () {
      let deviceId = this.$route.query.deviceId
      if (deviceId) {
        let query = this.$vueParse.device.getById(deviceId)
        query.first()
        .then(device => {
          if (device) {
            this.$store.commit('saveDevice', device)
            let site = device.get('site')
            if (site) {
              site.fetch().then(site => {
                this.$store.commit('saveSite', site)
              })
            }
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    getSite () {
      let siteCode = this.$route.params.hotel
      console.log('siteCode', siteCode)
      let query = this.$vueParse.site.get(siteCode)
      query.first()
      .then(site => {
        if (site) {
          site.fetch().then(site => {
            this.$store.commit('saveSite', site)
          })
        }
      })
    },
    getPackage () {
      if (packageJson.version !== this.$ls.get('DSR/version')) {
        localStorage.clear()
        console.log('Version updated, localstorage cleared', packageJson.version)
        this.$ls.set('DSR/version', packageJson.version)

        /*
        caches.keys().then(function (keyList) { // TODO : do this only for our application cache
          return Promise.all(keyList.map(function (key) {
            console.log('Cachestorage deleted', key)
            return caches.delete(key)
          }))
        })
        */
      }
    }
  },
  watch: {
    /**
     * Reload page on device update
     */
    device (device) {
      if (device) {
        var query = new this.$vueParse.Parse.Query('Device')
        query.equalTo('objectId', device.id)

        let subscription = query.subscribe()

        subscription.on('update', (device) => {
          this.$store.commit('saveDevice', device)
        })
      }
    }
  }
}
</script>
<style lang=scss>
html {
  font-size: 1.8vh;

  #app {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue